import { motion } from "framer-motion";
import { useLanguage } from "@/contexts/LanguageContext";

const claimMeta = [
  { value: "100%", key: "protein", target: "science" },
  { value: "100%", key: "pcr",     target: "science" },
  { value: "\u221290%", key: "cost",   target: "biosafety" },
  { value: "54%",  key: "yield",   target: "science" },
  { value: "254nm", key: "uv",     target: "technology" },
  { value: "Scale-Up", key: "scale", target: "strategy" },
];

export default function ScientificClaims() {
  const { t } = useLanguage();
  const handleClick = (target) => {
    document.getElementById(target)?.scrollIntoView({ behavior: "smooth" });
  };

  const claims = claimMeta.map(c => ({
    ...c,
    label: t(`claims.cards.${c.key}L`),
    desc: t(`claims.cards.${c.key}D`),
  }));

  return (
    <section id="claims" data-testid="claims-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-sm uppercase tracking-[0.2em] text-[#4B5563] font-medium font-mono mb-16 text-center"
        >
          {t("claims.heading")}
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E5E7EB]">
          {claims.map((claim, i) => (
            <motion.button
              key={claim.key}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              onClick={() => handleClick(claim.target)}
              className="bg-white p-8 md:p-12 group text-left cursor-pointer relative overflow-hidden transition-colors duration-300 hover:bg-[#F8FAFF]"
              data-testid={`claim-card-${i}`}
            >
              <div className="absolute bottom-0 left-0 w-full h-0.5 bg-[#EE1D25] origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" />
              <span className="font-heading text-5xl md:text-6xl font-black text-[#EE1D25] tracking-tighter block mb-4 group-hover:translate-x-1 transition-transform duration-300">
                {claim.value}
              </span>
              <h3 className="font-heading text-base font-semibold text-[#111827] mb-2 group-hover:text-[#EE1D25] transition-colors duration-300">{claim.label}</h3>
              <p className="text-sm text-[#4B5563] leading-relaxed">{claim.desc}</p>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
